module.exports = __webpack_public_path__ + "static/aboutchoose-add2acfc65498a8ed896405d5c10265f.jpg";